<template>
  <div>
    <div class="study">
      <div class="study-play">
        <rules></rules>
      </div>
    </div>

    <law></law>
    <div class="nameSearch">
      <div class="nameSearch-Play">
        <name-search></name-search>
      </div>
    </div>

    <div class="content">
      <div class="content-play">
       <operation></operation>
      </div>
    </div>
  </div>
</template>

<script>
  import Rules from "./components/rules";
  import Law from "./components/law";
  import NameSearch from "./components/nameSearch";
  import Operation from "./components/operation";
  export default {
    name: "search",
    components: {Operation, NameSearch, Law, Rules},
    data(){
      return{
        starGradeArr: [1,7,9,4],//星级评分数组
      }
    },
    methods:{

    }
  }
</script>

<style scoped>
  .study{
    width: 100%;
    height: 33px;
    margin-top: 35px;
  }

  .study-play{
    width: 1320px;
    height: 30px;
    margin: 0 auto;
  }
  .nameSearch{
    width: 100%;
    height: 145px;
  }
  .nameSearch-Play{
    width: 1050px;
    height: 145px;
    margin: 0 auto;
  }
  .content{
    width: 100%;
    height: auto;
  }
  .content-play{
    width: 1050px;
    height: 200px;
    margin: 0 auto;
    padding-top: 1px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/search/search.vue